export const imageUpload = {
	addImage: "Adicionar imagem",
	validating: "Validando imagem...",
	verifyingDimensions: "Verificando dimensões e formato...",
	removeImage: "Remover imagem carregada",
	formatInfo: "JPG ou PNG até {{maxSize}}MB e {{width}}x{{height}}px.",
	ariaLabel: {
		fileInput: "Campo de entrada de arquivo para upload de imagem",
		uploadedImage: "Imagem do produto carregada",
		uploadHeading: "Cabeçalho de upload",
	},
	errors: {
		fileTooLarge: "Arquivo muito grande. Tamanho máximo: {{maxSize}}MB",
		fileInvalidType: "Tipo de arquivo inválido. Use apenas JPG ou PNG.",
		fileDimensionsTooLarge: "Dimensões muito grandes. Máximo: {{width}}x{{height}}px",
		generalError: "Erro ao fazer upload da imagem",
		validationError: "Erro ao validar imagem",
		invalidFile: "Arquivo inválido",
	},
};
